export default "__VITE_ASSET__Tla2YR2n__"